module.exports = __webpack_public_path__ + "img/martini-royale.2fedb9bd.jpg";